
import { mapGetters } from 'vuex';
export default {
	components: {
		breadcrumbs: () => import('../../components/pages/breadcrumbs.vue'),
		termsAndConditions: () => import('../../components/pages/terms-and-conditions.vue')
	},
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang'
        })
    }
}
